import { Component, inject, Input } from '@angular/core';
import { OnlinePaymentComponent } from 'src/app/pages/form/booking-handler/online-payment/online-payment.component';
import {
  InStorePaymentComponent
} from 'src/app/pages/form/booking-handler/in-store-payment/in-store-payment.component';
import { FormService } from 'src/app/services/form.service';
import { LoaderComponent } from 'src/app/ui/atoms/loader/loader.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-booking-handler',
    imports: [
        InStorePaymentComponent,
        OnlinePaymentComponent,
        LoaderComponent,
        TranslatePipe
    ],
    templateUrl: './booking-handler.component.html',
    styleUrl: './booking-handler.component.scss'
})
export class BookingHandlerComponent {
   public formService = inject(FormService);

  @Input({required: true}) formId: string;
}
